import React from 'react';
import Icon from "components/Icon";
import {FactData} from "types/Fact";
import IconName from "types/IconName";

type Props = {
    fact: FactData
}

function FactArticle({fact}: Props) {
    return (
        <li className="mt-8">
            <article className="flex">
                <Icon name={fact.icon ?? IconName.QUESTION_MARK_CIRCLE} className="mr-2 text-brand h-7 w-7 flex-shrink-0"/>
                <div>
                    <h3 className="font-semibold text-base text-gray-800">{fact.name}</h3>
                    <p className="text-sm leading-6 font-medium whitespace-pre-line">{fact.value}</p>
                </div>
            </article>
        </li>
    );
}

export default FactArticle;